import { MARK_CODES, type MarkCode } from '../../../shared/forms';
import './MarkSelector.css';

const ORDER: MarkCode[] = ['S', 'X', 'R', 'M', 'NA'];

/**
 * The marking code control, used once per inspection item.
 *
 * This is the most-tapped control in the app - a fitter hits it 73 times per
 * powered vehicle - so every option is a direct tap with no menu, and the
 * targets stay at the minimum comfortable size even on the narrowest phone.
 */
export function MarkSelector({
  value,
  onChange,
  itemLabel,
}: {
  value?: MarkCode | null;
  onChange: (mc: MarkCode) => void;
  itemLabel: string;
}) {
  return (
    <div className="marks" role="radiogroup" aria-label={`Marking for ${itemLabel}`}>
      {ORDER.map((code) => {
        const selected = value === code;
        return (
          <button
            key={code}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`mark mark-${code}${selected ? ' is-on' : ''}`}
            onClick={() => onChange(code)}
            title={`${MARK_CODES[code].label}${MARK_CODES[code].hint ? ` — ${MARK_CODES[code].hint}` : ''}`}
          >
            <span aria-hidden="true">{MARK_CODES[code].symbol}</span>
            <span className="sr-only">{MARK_CODES[code].label}</span>
          </button>
        );
      })}
    </div>
  );
}

export function MarkChip({ code }: { code: MarkCode | string }) {
  const meta = MARK_CODES[code as MarkCode];
  if (!meta) return null;
  return (
    <span className={`mark-chip mark-${code}`} title={meta.label}>
      {meta.symbol}
    </span>
  );
}

export { MARK_CODES };
export type { MarkCode };
